import { render, staticRenderFns } from "./star_rating.vue?vue&type=template&id=3e51d1eb&scoped=true&"
import script from "./star_rating.vue?vue&type=script&lang=js&"
export * from "./star_rating.vue?vue&type=script&lang=js&"
import style0 from "./star_rating.vue?vue&type=style&index=0&id=3e51d1eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51d1eb",
  null
  
)

export default component.exports